<template>

  <vs-popup :active.sync="isActiveLocal" title="Yeni Extra Oluştur" v-esc="escape">

    <div class="con-exemple-prompt" @keyup.enter="submitData">

      <vs-input id="name" name="İsim" v-validate="'required'" v-model="newProductExtra.name" class="w-full"
        label-placeholder="İsim" />
      <span class="text-danger text-sm" v-show="errors.has('İsim')">{{ errors.first('İsim')}}</span>

      <vs-textarea id="description" name="Açıklama" v-model="newProductExtra.description" class="w-full mt-4 mb-0"
        icon-pack="feather" icon="icon-calendar" label="Açıklama" />

      <v-select :disabled="rawMaterials.length == 0" id="product" name="Ürün" v-validate="'required'"
        v-model="newProductExtra.rawMaterial" itemid="id" @input="newProductExtra.unit = newProductExtra.rawMaterial ? newProductExtra.rawMaterial.unit : {}"
        label="name" placeholder="Hammadde Seçimi.." :options="rawMaterials" class="mt-4" :clearable="true"></v-select>
      <span class="text-danger text-sm" v-show="errors.has('Ürün')">{{ errors.first('Ürün')}}</span>

      <vs-input id="quantity" name="Miktar" v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
        v-model="newProductExtra.unitPartQuantity" class="w-full" label-placeholder="Miktar" />
      <span class="text-danger text-sm" v-show="errors.has('Miktar')">{{ errors.first('Miktar')}}</span>

      <vs-input disabled="true" v-if="newProductExtra.rawMaterial != null" id="unit" name="Birim"
        v-model="newProductExtra.unit.name" class="w-full mt-4" />

      <vs-input id="price" name="Satış Fiyatı" v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
        v-model="newProductExtra.price" class="w-full" label-placeholder="Satış Fiyatı"> </vs-input>
      <span class="text-danger text-sm" v-show="errors.has('Satış Fiyatı')">{{ errors.first('Satış Fiyatı')}}</span>

      <vs-checkbox v-model="newProductExtra.isGlobal" class="py-4">Global mi ?</vs-checkbox>

      <vs-row vs-type="flex" vs-justify="space-between" vs-w="12" class="mt-4">
        <vs-button class="mr-auto giveUpAndSaveButtons" type="gradient" color="danger" @click="isActiveLocal = false">
          Vazgeç
        </vs-button>
        <vs-button type="gradient" icon-pack="feather" icon="icon-save" class="ml-auto giveUpAndSaveButtons" color="success"
          @click="submitData" >Kaydet</vs-button>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
  import {
    getRawMaterialNameList
  } from "@/api/RawMaterial"
  import {
    createNewProductExtra,
    updateProductExtra
  } from "@/api/ProductExtra"
  import {
    getAlternateUnits,
    getRootUnit
  } from "@/api/Unit";
  export default {
    props: {
      isActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        newProductExtra: {
          unit: {}
        },
        rawMaterials: [],

        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    methods: {
      escape() {
        if (this.isActiveLocal == true) this.isActiveLocal = false;
      },
      getRootUnit(unitId) {
        getRootUnit(unitId).then(res => {
          if (res && res.status == 200) {
            //this.newProductExtra.unit = res.data;
          }
        })
      },
      getAlternateUnits: function (val, isNew) {
        if (val) {
          let vm = this;
          getAlternateUnits(val.unit.id).then(res => {
            if (res && res.status == 200) {
              var alternateUnits = res.data;
              for (let i = 0; i < alternateUnits.length; i++) {
                if (i != 0) alternateUnits[i].originUnitQuantity = 1 * (alternateUnits[i].originUnitQuantity ||
                    1) *
                  (alternateUnits[i - 1].originUnitQuantity || 1);
                else alternateUnits[i].originUnitQuantity = 1;
              }
              val.alternateUnits = _.clone(alternateUnits);
              if (isNew == true) {
                vm.newProductExtra.unit = val.alternateUnits[0];
              }
            } else {
              vm.$vs.notify({
                color: 'danger',
                title: 'Hata : ' + res.status,
                text: 'Alternatif Birimler Yüklenemedi ! '
              });
            }
          }).catch((e) => {
            vm.$vs.notify({
              color: 'danger',
              title: 'Hata ! ',
              text: 'Sunucu Bağlantı Hatası ! '
            });
          });
        }
      },
      initValues() {
        this.newProductExtra = {
          unit: {}
        };
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll();
        if (checker) {
          //await this.mapNewBranch();
          this.newProductExtra.price = this.newProductExtra.price ? parseFloat(this.newProductExtra.price) : 0;
          this.newProductExtra.totalBuyPrice = this.newProductExtra.totalBuyPrice ? parseFloat(this.newProductExtra.totalBuyPrice) : 0;
          this.newProductExtra.unitPartQuantity = this.newProductExtra.unitPartQuantity ? parseFloat(this.newProductExtra.unitPartQuantity) : 0;
          if (this.newProductExtra.id) {
            updateProductExtra(this.newProductExtra).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("productExtra/updateProductExtra", res.data).then(() => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Ekstra Başarıyla Güncellendi !'
                  });
                  this.$emit('close');
                  this.initValues();
                  this.$validator.reset();
                })
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Ekstra Güncelleme Başarısız !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newProductExtra.id = 0;
            createNewProductExtra(this.newProductExtra).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("productExtra/addProductExtra", res.data).then(() => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı',
                    text: 'Ekstra Ekleme Başarılı !'
                  });
                  this.$emit('close');
                  this.initValues();
                  this.$validator.reset();
                })
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Sunucu Bağlantı Hatası !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          }
        }
      },
      getRawMaterialNameList: function () {
        getRawMaterialNameList().then(res => {
          this.rawMaterials = res.data;
        });
      },
    },
    computed: {
      isActiveLocal: {
        get() {
          return this.isActive
        },
        set(val) {
          if (!val) {
            this.$emit('close')
            this.initValues();
            this.$validator.reset()
          }
        }
      }
    },
    mounted: function () {
      this.getRawMaterialNameList();
    },
    created: function () {
      /*this.$validator.extend('checkDouble',{
        getMessage : 'Lütfen Doğru Format Girin Örn : 2.25',
        validate : function(value,field){

        }
      })*/
    },
    watch: {
      isActive: function (val) {
        if (!val) return
        if (Object.entries(this.data).length == 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.newProductExtra = _.cloneDeep(this.data);
          //this.getAlternateUnits(this.newProductExtra.rawMaterial, false);
          //this.getRootUnit(this.newProductExtra.rawMaterial.unit.id);
        }
      }
    }
  }

</script>

<style>
  .vs-con-tbody.vs-table--tbody {
    min-height: 300px !important;
  }

  .vs__selected-options {
    flex-wrap: nowrap !important;
  }

  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }

  .vs-popup {
    max-width: 500px !important;
    width: 100% !important;
  }

</style>
